<div class="review-rating">
    <ul class="rating">
        <li class="fas fa-star"></li>
        <li class="fas fa-star"></li>
        <li class="fas fa-star"></li>
        <li class="far fa-star"></li>
        <li class="far fa-star"></li>
    </ul>
</div>
